
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { networkService } from '@/services/network.service';
import { getEnhancedPrimaryList } from '@/services/shopping/lists/primary-list-enhanced.service';
import { safeToastError, safeToastInfo } from '@/components/ui/toastManager';
import OfflineLogger from '@/utils/offlineLogger';

export function useNavigationFix() {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);

  const navigateToShopping = async () => {
    if (isNavigating) return;
    
    try {
      setIsNavigating(true);
     // OfflineLogger.info('useNavigationFix', 'Starting navigation to shopping');

      // Assicurati che esista una lista primaria
      const primaryList = await getEnhancedPrimaryList();
      
      if (!primaryList) {
        OfflineLogger.error('useNavigationFix', 'Cannot navigate: no primary list available');
        safeToastError('Impossibile accedere alla lista della spesa');
        return;
      }

      //OfflineLogger.info('useNavigationFix', `Navigating to shopping with list ${primaryList.id}`);
      
      // Naviga alla pagina shopping con l'ID della lista
      navigate(`/shopping?list=${primaryList.id}`);
      
      if (!networkService.isOnline()) {
        safeToastInfo('Modalità offline attiva');
      }

    } catch (error) {
      OfflineLogger.error('useNavigationFix.navigateToShopping', error);
      safeToastError('Errore durante la navigazione alla lista della spesa');
    } finally {
      setIsNavigating(false);
    }
  };

  return {
    navigateToShopping,
    isNavigating
  };
}
